import styled from 'styled-components';
import { tokens } from '../../../design/tokens';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  flex-wrap: wrap;
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${tokens.color.cardCharcoal};
  border: 1px solid ${tokens.color.railGraphite};
  border-radius: ${tokens.radius.pill};
  padding: 0 12px;
  color: ${tokens.color.textAsh};
  flex: 1;
  min-width: 200px;

  /* O input zera o próprio outline; o foco aparece na caixa inteira. */
  &:focus-within {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }
`;

export const SearchInput = styled.input`
  background: transparent;
  border: 0;
  color: ${tokens.color.textWhite};
  font-size: ${tokens.font.body.size};
  padding: 10px 0;
  width: 100%;

  &::placeholder {
    color: ${tokens.color.textAsh};
  }

  &:focus {
    outline: none;
  }
`;

export const Select = styled.select`
  background: ${tokens.color.cardCharcoal};
  border: 1px solid ${tokens.color.railGraphite};
  border-radius: ${tokens.radius.pill};
  color: ${tokens.color.textWhite};
  font-size: ${tokens.font.body.size};
  padding: 10px 32px 10px 16px;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }
`;

export const Count = styled.span`
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.caption.size};
  white-space: nowrap;
`;
